import * as React from 'react';
import { ActionModal } from '@/components/ui/ActionModal';
import { useUiStore } from '@/store/uiStore';

export const AlertModal: React.FC = () => {
  const isOpen = useUiStore((state) => state.modals.alert);
  const config = useUiStore((state) => state.alertConfig);
  const closeModal = useUiStore((state) => state.closeModal);

  if (!config) return null;

  const handlePrimary = async () => {
    if (config.primaryAction) {
      await config.primaryAction();
    }
    closeModal('alert');
  };

  const secondaryAction = config.secondaryAction;
  const handleSecondary = secondaryAction
    ? async () => {
        try {
          await secondaryAction();
        } finally {
          closeModal('alert');
        }
      }
    : undefined;

  const secondaryProps: { secondaryLabel?: string; onSecondary?: () => void | Promise<void> } = {};
  if (config.secondaryLabel) secondaryProps.secondaryLabel = config.secondaryLabel;
  if (handleSecondary) secondaryProps.onSecondary = handleSecondary;

  return (
    <ActionModal
      isOpen={isOpen}
      onClose={() => closeModal('alert')}
      title={config.title}
      message={config.message}
      primaryLabel={config.primaryLabel}
      onPrimary={handlePrimary}
      {...secondaryProps}
    />
  );
};
